document.addEventListener('DOMContentLoaded', function () {
  var guides = document.querySelectorAll('[data-fl-size-guide]');
  guides.forEach(function (root) {
    var viewBtns = root.querySelectorAll('.fl-size-guide__tabs button[data-fl-view]');
    var views = root.querySelectorAll('.fl-size-guide__view[data-fl-view]');
    function setView(name) {
      viewBtns.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-fl-view') === name);
      });
      views.forEach(function (v) {
        v.classList.toggle('is-active', v.getAttribute('data-fl-view') === name);
      });
    }
    viewBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        setView(b.getAttribute('data-fl-view'));
      });
    });

    // the chart is the default view; override per instance with
    // data-fl-default-view="table" on the [data-fl-size-guide] root
    setView(root.getAttribute('data-fl-default-view') || 'chart');

    var unitBtns = root.querySelectorAll('[data-fl-unit]');
    var cells = root.querySelectorAll('[data-in]');
    function applyUnit(unit) {
      unitBtns.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-fl-unit') === unit);
      });
      cells.forEach(function (c) {
        c.textContent = c.getAttribute('data-' + unit);
      });
    }
    unitBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        applyUnit(b.getAttribute('data-fl-unit'));
      });
    });
  });
});